import { useEffect, useRef } from "react";
import { useWheelbaseComponents } from "../../lib/useWheelbaseComponents";
import { WHEELBASE_THEME_ATTRS, useWheelbaseConfig } from "../../lib/wheelbase";
import {
  paintWheelbasePortals,
  paintWheelbaseShadow,
  WHEELBASE_CHECKOUT_CSS,
  WHEELBASE_PORTAL_CSS,
} from "../../lib/wheelbaseSkin";
import type { Rig } from "../../lib/bookingApi";

interface Props {
  rig: Rig;
}

const WheelbaseCheckout = ({ rig }: Props) => {
  const config = useWheelbaseConfig();
  const loaded = useWheelbaseComponents("listing-details");
  const hostRef = useRef<HTMLDivElement>(null);
  const rentalId = config?.rentals[rig];

  useEffect(() => {
    if (!loaded) {
      return;
    }
    const host = hostRef.current?.querySelector("listing-details");
    if (!host) {
      return;
    }

    const apply = () => {
      paintWheelbaseShadow(host, WHEELBASE_CHECKOUT_CSS);
      paintWheelbasePortals(WHEELBASE_PORTAL_CSS);
    };
    apply();

    const observer = new MutationObserver(() => {
      apply();
    });
    observer.observe(host, { childList: true, subtree: true });
    if (host.shadowRoot) {
      observer.observe(host.shadowRoot, { childList: true });
    }
    observer.observe(document.body, { childList: true });

    return () => {
      observer.disconnect();
    };
  }, [loaded, rentalId]);

  if (!config || !rentalId || !loaded) {
    return <p className="text-zinc-500 text-sm">Loading…</p>;
  }

  return (
    <div ref={hostRef} className="wheelbase-host overflow-visible">
      <listing-details
        dealer-id={config.dealerId}
        rental-id={rentalId}
        locale="en-us"
        {...WHEELBASE_THEME_ATTRS}
      />
    </div>
  );
};

export default WheelbaseCheckout;
